// Given a Pixel value, return the unit to match the REM size the html
export const rem = (pxValue) => { // html font-size = 62.5% or 10px;
  return (pxValue / 10) + "rem";
}

// Given a Pixel value, return the unit to match the EM size of the body or provided baseline
export const em = (pxValue, baselinePx = 18, unitless = false) => { // body font-size = 1.8rem or 18px;
  let value = (pxValue / baselinePx);
  if (!unitless) {
    value += 'em';
  }
  return value;
}

// unitless EM value (mostly for line-height)
export const emu = (pxValue, baselinePx = 18) => em(pxValue, baselinePx, true);


// grid-gutter-width
export const spacer =  32; // unitless pixel size (to be used with rem() or em() conversion)